import { ReactElement } from 'react';
import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import PmiTextField from 'shell/components/shared/text-field';
import { RequestMunicipalNumberVM } from 'civil-status/view-models/municipal-number';
import ListRegister from '../../shared/list-register';

const RequestMunicipalNumberForm = (): ReactElement => {
  const formContext = useFormikContext<RequestMunicipalNumberVM>();

  const onChangeRegister = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('register', event.target.value);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <ListRegister
          value={formContext.values.register || ''}
          error={Boolean(formContext.errors.register) && formContext.touched.register}
          onChange={onChangeRegister}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Anno dichiarazione *"
          aria-label="Anno dichiarazione"
          id="year"
          fullWidth
          inputProps={{
            maxLength: '4',
          }}
          onChange={(event) => {
            formContext.setFieldValue('year', event.target.value);
          }}
          value={formContext.values?.year || ''}
          helperText={formContext.errors?.year}
          error={formContext.touched?.year && Boolean(formContext.errors?.year)}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Numero elementi *"
          aria-label="Numero elementi"
          id="numberElement"
          fullWidth
          inputProps={{
            maxLength: '4',
          }}
          onChange={(event) => {
            formContext.setFieldValue('numberElement', event.target.value);
          }}
          value={formContext.values?.numberElement || ''}
          helperText={formContext.errors?.numberElement}
          error={formContext.touched?.numberElement && Boolean(formContext.errors?.numberElement)}
        />
      </Grid>
      <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center' }}>
        <PmiButton variant="outlined" color="cdmBrandThird" fullWidth type="submit">
          Richiedi
        </PmiButton>
      </Grid>
    </Grid>
  );
};

RequestMunicipalNumberForm.displayName = 'Request Municipal Number Form component';

export default RequestMunicipalNumberForm;
